// user
export const login_event = "webapp_login";
export const logout_event = "webapp_logout";
export const toggle_dark_mode_event = "webapp_toggle_dark_mode";
export const toggle_light_mode_event = "webapp_toggle_light_mode";

// navigation
export const goto_documentation_event = "webapp_goto_documentation";
export const goto_manage_subscription_event = "webapp_goto_manage_subscription";
export const goto_teams_event = "webapp_goto_teams";
export const goto_team_event = "webapp_goto_team";
export const goto_workspace_event = "webapp_goto_workspace";
export const goto_promptbook_event = "webapp_goto_promptbook";
export const goto_discord_event = "webapp_goto_discord";
export const goto_manage_payments_event = "webapp_goto_manage_payments";
export const goto_checkout_event = "webapp_goto_checkout";

// comms
export const comms_contact_sales_event = "webapp_comms_contact_sales";

// teams
export const create_team_event = "webapp_create_team";
export const delete_team_event = "webapp_delete_team";
export const rename_team_event = "webapp_rename_team";
export const send_invite_event = "webapp_send_invite";
export const resend_invite_event = "webapp_resend_invite";
export const accept_invite_event = "webapp_accept_invite";
export const update_team_member_role_event = "webapp_update_team_member_role";
export const remove_team_member_event = "webapp_remove_team_member";

// workspaces
export const create_workspace_event = "webapp_create_workspace";
export const delete_workspace_start_event = "webapp_delete_workspace_start";
export const delete_workspace_complete_event = "webapp_delete_workspace_complete";
export const rename_workspace_event = "webapp_rename_workspace";

// promtbooks
export const create_promptbook_event = "webapp_create_promptbook";
export const create_workspace_key_event = "webapp_create_workspace_key";
export const delete_promptbook_complete_event = "webapp_delete_promptbook_complete";
export const delete_promptbook_start_event = "webapp_delete_promptbook_start";
export const rename_promptbook_event = "webapp_rename_promptbook";
export const run_promptbook_event = "webapp_run_promptbook";

// files
export const upload_file_event = "webapp_upload_file";

// errors
export const error_event = "webapp_error";

// signup form
export const signup_form_complete_event = "webapp_signup_form_complete";

// onboarding
export const onboarding_complete_event = "webapp_onboarding_complete";
export const onboarding_next_event = "webapp_onboarding_next";
export const onboarding_enable_event = "webapp_onboarding_enable";
export const onboarding_disable_event = "webapp_onboarding_disable";
export const onboarding_start_event = "webapp_onboarding_start";
export const onboarding_welcome_close_event = "webapp_onboarding_welcome_close";

// editor
export const promptbook_editor_upload_file_event = "webapp_editor_upload_file";
export const promptbook_editor_apply_suggestion_event = "webapp_editor_apply_suggestion";

// templates
export const save_promptbook_as_template_event = "webapp_save_promptbook_as_template_event";
export const open_template_modal_event = "webapp_open_template_modal";
export const select_template_event = "webapp_select_template";

// connectors
export const open_connector_modal_event = "webapp_open_connector_modal";
export const create_connector_event = "webapp_create_connector";
export const delete_connector_event = "webapp_delete_connector";
export const rename_connector_event = "webapp_rename_connector";
